import {Injectable} from '@angular/core';
import {BaseService} from '@core/service/base.service';
import {HttpClient} from '@angular/common/http';
import {catchError, tap} from 'rxjs/operators';


@Injectable({providedIn: 'root'})
export class ScoringValueService extends BaseService {

  private url = 'api/scoring-value';  // URL to web api

  constructor(http: HttpClient) {
    super(http);
  }

  getUrl(): string {
    return this.url;
  }

  /**
   * 根据评分方案明细id获取值
   * @param detailId 评分方案明细id
   */
  getByScoringSchemeDetailId(detailId: string): any {
    const url = `${this.getUrl()}/${detailId}`;
    return this.http.get<any>(url).pipe(
      tap(() => this.log(`fetched object detailId=${detailId}`)),
      catchError(this.handleError<any>(`get any detailId=${detailId}`)),
    );
  }

  /**
   * 根据评分方案明细id获取当前人员的值
   * @param detailId 评分方案明细id
   */
  getCurrentByScoringSchemeDetailId(detailId: string, info?: string): any {
    let url: string;
    if (info === 'current') {
      url = `${this.getUrl()}/${detailId}`;
    } else {
      url = `${this.getUrl()}/${detailId}/current`;
    }
    return this.http.get<any>(url).pipe(
      tap(() => this.log(`fetched object detailId=${detailId}`)),
      catchError(this.handleError<any>(`get any detailId=${detailId}`)),
    );
  }

  /**
   * 重新评分
   * @param scoringPersonId 评分人员id
   */
  reScoring(scoringPersonId: string): any {
    const url = `${this.getUrl()}/re-scoring/${scoringPersonId}`;
    return this.http.get<any>(url).pipe(
      tap(() => this.log(`reScoring scoringPersonId=${scoringPersonId}`)),
      catchError(this.handleError<any>(`reScoring scoringPersonId=${scoringPersonId}`)),
    );
  }

  /**
   * 禁止评分
   * @param scoringPersonId 评分人员id
   */
  disableScoring(scoringPersonId: string): any {
    const url = `${this.getUrl()}/disable-scoring/${scoringPersonId}`;
    return this.http.get<any>(url).pipe(
      tap(() => this.log(`disableScoring scoringPersonId=${scoringPersonId}`)),
      catchError(this.handleError<any>(`disableScoring scoringPersonId=${scoringPersonId}`)),
    );
  }

}

